import { productsFromStore } from './products-from-store.js';
import { checkoutFinishData } from './checkout-finish-data.js';

/**
 * @param {OrderData} order
 * @param storeItems
 * @returns {*}
 */
export function createCheckoutFinish(order, storeItems) {
    return productsFromStore(storeItems)
        .then((products) => checkoutFinishData(order, products));
}
